import { Button, Form, Row, Space, Table, theme } from "antd";
import WorktimeTable from "../../fragments/worktime-table";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { 
  useCreateAbsenceEmployeeClosuresCrossReferenceMutation, 
  useCreateEmployeeClosureMutation, 
  useCreateWorkTimeEmployeeClosuresCrossReferenceMutation, 
  useDeleteAbsenceEmployeeClosuresCrossReferenceMutation, 
  useDeleteEmployeeClosureMutation, 
  useDeleteWorkTimeEmployeeClosuresCrossReferenceMutation, 
  useGetAbsenceEmployeeClosuresCrossReferencesQuery, 
  useGetAbsencesQuery, 
  useGetCustomerQuery, 
  useGetEmployeeClosureQueryQuery, 
  useGetNoVisitReasonsQuery, 
  useGetWorkTimeEmployeeClosuresCrossReferencesQuery, 
  useGetWorkTimes2Query, 
  useUpdateNoVisitReasonMutation 
} from "../../../../api/plamo-api";
import dayjs from "dayjs";
import AbsenceTable from "../../fragments/absence-table";
import NoVisitReasonTable from "../../fragments/no-visit-reason-table";
import FormItem from "../../form/form-item";
import { useNavigate, useSearchParams } from "react-router-dom";
import ConfirmButton from "../../util/confirm-button";

const formatTime = (workTimesSum: any) => {
  return (workTimesSum || 0).toFixed(2).replace('.', ',');
}

const calcDuration = wt => {
  const diff = (dayjs(wt.endTimeEmployee).valueOf() - dayjs(wt.startTimeEmployee).valueOf()) / 1000 / 60;
  return (diff / 60).toFixed(2).replace('.', ',');
}

const calcWorkTimesSum = (wts: any[]): number => {
  return wts.map(wt => (dayjs(wt.endTimeEmployee).valueOf() - dayjs(wt.startTimeEmployee).valueOf()) / 1000 / 60 / 60).reduce((p: number, c: number) => p + c, 0);
}

const calcDistancesFromSum = (wts: any[]): number => {
  console.log("Distances from sum", wts.map(wt => wt.distanceFromManual), wts);
  return wts.map(wt => wt.distanceFromManual).reduce((p: number, c: number) => p + (c || 0), 0);
}

const calcDistancesToSum = (wts: any[]): number => {
  return wts.map((wt, idx) => (wts || [])[idx + 1]?.arrivalFromPreviousCustomer ? 0 : wt.distanceToManual).reduce((p: number, c: number) => p + (c || 0), 0);
}

const calcDistancesShoppingSum = (wts: any[]): number => {
  const result =  wts.map((wt) => wt.distanceShopping).reduce((p: number, c: number) => p + (c || 0), 0);
  console.log("Distances shopping", result, wts, wts.map(wt => wt.distanceShopping))
  return result;
}

const calcAbsencesSum = (absences: any[]): number => {
  return absences.map(a => a.workingDays || 0).reduce((p: number, c: number) => p + c, 0);
}

const calcAbsenceHours = (employee: any, absencesSum: any): number => {
  const hoursPerDay = (employee?.worktimePerWeek || 0) / 5;
  return absencesSum * hoursPerDay;
}

const ReportCustomerName = ({ record }) => {
  const { data: customer } = useGetCustomerQuery({ id: record.customerId }, { skip: !record.customerId }) as any;
  return <>
    {customer && !record.substitute && `${customer.firstName} ${customer.lastName}`}
    { !!record.otherTask && record.otherTask }
    { !record.otherTask && record.substitute && `${record.substitutionCustomerFirstName} ${record.substitutionCustomerLastName} (Vertr.)` }
  </>;
}

const months = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];

function EmployeeClosureDetails({ employeeId, employee, employeeClosureId }) {
  const userToken = useSelector(state => (state as any).user?.userToken);
  const navigate = useNavigate();
  const [search] = useSearchParams();
  const preselectedMonthStr = search.get('preselectedMonth');

  console.log("Employee closure id", employeeClosureId)

  const employeeClosureIdInt = useMemo(() => employeeClosureId === 'new' ? 0 : parseInt(employeeClosureId), [employeeClosureId]);
  const { data: closure } = useGetEmployeeClosureQueryQuery({ id: employeeClosureIdInt }, { skip: employeeClosureId === 'new' }) as any;
  const { data: workTimes } = useGetWorkTimes2Query({ f: JSON.stringify({ "employeeClosureId": { c: "EQ", v: employeeClosureIdInt }, "changeRequestForId": { c: "EQ", v: null } }), st: JSON.stringify({ "startTime": "asc" }) }, { skip: employeeClosureId === 'new' }) as any;
  const { data: absences } = useGetAbsencesQuery({ f: JSON.stringify({ "employeeClosureCrossReference.employeeClosure.id": { c: "EQ", v: employeeClosureIdInt } }), st: JSON.stringify({ "id": "asc" }) }, { skip: employeeClosureId === 'new' }) as any;
  const { data: noVisitReasons } = useGetNoVisitReasonsQuery({ f: JSON.stringify({ "employeeClosure.id": { c: "EQ", v: employeeClosureIdInt } }), st: JSON.stringify({ "id": "asc" }) }, { skip: employeeClosureId === 'new' }) as any;
  const pdfReportContentRef = useRef<any>();
  const [form] = Form.useForm();
  const [filter, setFilter] = useState<any>({})
  const selectedMonth = useMemo(() => filter.month, [filter])
  const begin = useMemo(() => dayjs(`${selectedMonth?.format('YYYY-MM')}-01T00:00:00.000Z`),  [selectedMonth])
  const end = useMemo(() => dayjs(begin).add(1, 'month'),  [begin])

  const { data: workTimesNew } = useGetWorkTimes2Query({ f: JSON.stringify({"employeeId": { c: "EQ", v: employeeId }, "employeeClosureCrossReferenceId": { c: "EQ", v: null } }), st: JSON.stringify({ "startTime": "desc" })}, { skip: employeeClosureId !== 'new' }) as any;
  const { data: absencesNew } = useGetAbsencesQuery({ f: JSON.stringify({"employee.id": { c: "EQ", v: employeeId }, "employeeClosureCrossReference": { c: "EQ", v: null } }), st: JSON.stringify({ "begin": "desc" })}, { skip: employeeClosureId !== 'new' }) as any;
  //const { data: noVisitReasonsNew } = useGetNoVisitReasonsQuery({ f: JSON.stringify({"month": { c: "EQ", v: dayjs(begin).utc().format('YYYY-MM') + '-01T00:00:00.000', t: 'DATE'}})}, { skip: employeeClosureId !== 'new' }) as any;
  const relevantWorkTimes = useMemo(() => workTimesNew?.items?.filter((wt: any) => dayjs(wt.startTime).format('YYYY/MM') === dayjs(begin).format('YYYY/MM')), [workTimesNew?.items, begin])
  const workTimesSum = useMemo(() => relevantWorkTimes ? calcWorkTimesSum(relevantWorkTimes) : 0, [relevantWorkTimes])
  const workTimesSumStr = useMemo(() => workTimesSum ? formatTime(workTimesSum) : '', [workTimesSum]);

  console.log("Work times", workTimesNew, relevantWorkTimes, workTimesSum)

  const relevantAbsences = useMemo(() => absencesNew?.items?.filter((wt: any) => dayjs(wt.begin).format('YYYY/MM') === dayjs(begin).format('YYYY/MM')), [absencesNew?.items, begin])
  const absencesSum = useMemo(() => relevantAbsences ? calcAbsencesSum(relevantAbsences) : 0, [relevantAbsences])
  const absenceHours = useMemo(() => calcAbsenceHours(employee, absencesSum), [employee, absencesSum])
  //const hoursExpected = useMemo(() => calcHoursExpected(employee, begin, end, publicHolidays), [employee, begin, end, publicHolidays?.items])
  const [createEmployeeClosure] = useCreateEmployeeClosureMutation();
  const [deleteEmployeeClosure] = useDeleteEmployeeClosureMutation();
  const [createWorkTimeEmployeeClosureCrossReference] = useCreateWorkTimeEmployeeClosuresCrossReferenceMutation();
  const [createAbsenceEmployeeClosureCrossReference] = useCreateAbsenceEmployeeClosuresCrossReferenceMutation();
  const { data: workTimesCrossReferences } = useGetWorkTimeEmployeeClosuresCrossReferencesQuery({ f: JSON.stringify({ "employeeClosure.id" : {c: "EQ", v: employeeClosureIdInt }})}, { skip: !employeeClosureIdInt}) as any;
  const { data: absencesCrossReferences } = useGetAbsenceEmployeeClosuresCrossReferencesQuery({ f: JSON.stringify({ "employeeClosure.id" : {c: "EQ", v: employeeClosureIdInt }})}, { skip: !employeeClosureIdInt}) as any;
  const [deleteWorkTimeCrossReference] = useDeleteWorkTimeEmployeeClosuresCrossReferenceMutation();
  const [deleteAbsenceCrossReference] = useDeleteAbsenceEmployeeClosuresCrossReferenceMutation();
  const [updateNoVisitReason] = useUpdateNoVisitReasonMutation();
  const [creatingClosure, setCreatingClosure] = useState<boolean>(false);

  console.log("Absences", absencesSum, absenceHours);

  const totalDistance = useMemo(() => workTimes?.items ? (calcDistancesFromSum(workTimes.items) + calcDistancesToSum(workTimes.items) + calcDistancesShoppingSum(workTimes.items)).toFixed(1).replace('.', ',') : '', [workTimes])

  useEffect(() => {
    if(preselectedMonthStr) {
      const month = dayjs(preselectedMonthStr + '-01T00:00:00.000');
      setFilter((f: any) => ({ ...f, month }));
      form.setFieldsValue({ month });
    }
  }, [preselectedMonthStr, setFilter, form])

  console.log("filter", filter);

  const generatePdf = useCallback(async () => {
    const pdfReportContent = pdfReportContentRef.current?.innerHTML;

    const html = `
      <style type="text/css">
        table {
          width: 100%;
          border-collapse: collapse;
        }

        th, td {
          border: 1px solid black;
          text-align: center;
        }        
      </style>

      ${pdfReportContent}
    `

    const response = await fetch("/api/plamo/contract-template/pdf", { method: 'POST', body: html, headers: { 'Content-Type': 'text/html', 'Authorization': `Bearer ${userToken}` } });
    const blob = await response.blob()
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a") as any;
    document.body.appendChild(a);
    a.style = "display: none";
    a.href = url;
    a.download = "Stundenzettel.pdf";
    a.click();
    window.URL.revokeObjectURL(url);
  }, [userToken, pdfReportContentRef])

  const { token } = theme.useToken();
    
  const formStyle: React.CSSProperties = {
    maxWidth: 'none',
    background: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    padding: 24,
  };

  const onFieldsChange = useCallback((_, allFields) => {
    const values = form.getFieldsValue()
    if(JSON.stringify(values) !== JSON.stringify(filter)) {
      setFilter(values)
    }
  }, [form, filter, setFilter])

  const saveClosure = useCallback(async () => {
    setCreatingClosure(true);
    const monthStr = months[dayjs(selectedMonth).month()]
    const monthYearStr = monthStr + " " + dayjs(selectedMonth).format('YYYY')
    const title = `Abschluss ${monthYearStr} ${employee?.firstName} ${employee?.lastName}`
    const employeeClosure = {
      employeeId,
      begin,
      end,
      title,
      hoursSum: workTimesSum,
      /*
      hoursExpected,
      */
      hoursAbsence: absenceHours,
      /*
      hoursRemaining: parseFloat(hoursDiff),*/
    }

    const { data: createdEmployeeClosure } = (await createEmployeeClosure(employeeClosure)) as { data: any };

    let crossReferencePromises = relevantWorkTimes.map(wt => {
      const cr = {
        employeeClosureId: createdEmployeeClosure.id,
        workTimeId: wt.id
      }
      return createWorkTimeEmployeeClosureCrossReference(cr);
    })

    await Promise.all(crossReferencePromises)

    crossReferencePromises = relevantAbsences.map(a => {
      const cr = {
        employeeClosureId: createdEmployeeClosure.id,
        absenceId: a.id
      }
      return createAbsenceEmployeeClosureCrossReference(cr);
    })

    await Promise.all(crossReferencePromises)

    /*
    const noVisitReasonPromises = noVisitReasonsItems?.map(r => {
      const newReason = {...r, employeeClosureId: createdEmployeeClosure.id}
      return updateNoVisitReason(newReason);
    }) as any;

    await Promise.all(noVisitReasonPromises);
    */
   setCreatingClosure(false);

    navigate(`/employee/${employeeId}/settlement/closure/${createdEmployeeClosure.id}`, { replace: true })
  }, [createEmployeeClosure, createWorkTimeEmployeeClosureCrossReference,
    createAbsenceEmployeeClosureCrossReference,
    begin, end, workTimesSum, relevantWorkTimes, relevantAbsences, absenceHours,
    employeeId, employee,
    selectedMonth, navigate, setCreatingClosure]);

  const onDelete = useCallback(async () => {
    let promises = (workTimesCrossReferences?.items || []).map(c => deleteWorkTimeCrossReference(c));

    await Promise.all(promises);

    promises = (absencesCrossReferences?.items || []).map(a => deleteAbsenceCrossReference(a));

    await Promise.all(promises);

    promises = noVisitReasons?.items?.map(r => ({...r, employeeClosureId: null})).map(updateNoVisitReason)

    await Promise.all(promises)

    await deleteEmployeeClosure({ id: employeeClosureIdInt})

    navigate(-1);
  }, [workTimesCrossReferences?.items, employeeClosureIdInt, navigate, deleteEmployeeClosure, deleteWorkTimeCrossReference, absencesCrossReferences,
    noVisitReasons?.items, updateNoVisitReason, deleteAbsenceCrossReference
  ])

  return (<>
    { employeeClosureId !== 'new' && 
    <div style={{ textAlign: 'right' }}>
      <Space size="small">
        <Button type="primary" onClick={() => generatePdf()}>
          PDF erstellen
        </Button>
      </Space>
    </div>
    }
    {
      employeeClosureId === 'new' &&
      <>
       <Form form={form} style={formStyle} onFieldsChange={onFieldsChange}>
          <Row><h3>Filter</h3></Row>
          <Row gutter={24}>
            <FormItem fieldName="month" label="Monat" type="month" />
          </Row>
        </Form>

        <div>
          <Space size="small">
            <Button type="primary" onClick={() => saveClosure()} disabled={creatingClosure} loading={creatingClosure}>
              Abrechnung erstellen
            </Button>
          </Space>
        </div>
      </>
    }

    <h2>Zusammenfassung</h2>

    <Table
    pagination={false} 
    columns={[
      {
        title: "Beschreibung",
        dataIndex: "ident",
      },
      {
        title: "Summe",
        dataIndex: "sum",
      },
    ]}
    dataSource={[
      {
        ident: "Stunden geleistet",
        sum: employeeClosureId === 'new' ? workTimesSumStr : formatTime(closure?.hoursSum)
      },
      {
        ident: "Urlaub (Tage)",
        sum: employeeClosureId === 'new' ? absencesSum : (closure?.absenceVacation || 0)
      },
      {
        ident: "AU",
        sum: employeeClosureId === 'new' ? absencesSum : (closure?.absenceSickLeave || 0)
      },
      /*
      {
        ident: "Stunden erwartet",
        sum: employeeClosureId === 'new' ? hoursExpected : formatTime(closure?.hoursExpected - closure?.hoursAbsence)
      },
      {
        ident: "Über-/Minusstunden",
        sum: (closure?.hoursRemaining > 0 ? "- " : "+ ") + formatTime(Math.abs(closure?.hoursRemaining))
      },
      */
      {
        ident: "Gesamt KM",
        sum: totalDistance
      }
    ]}
    />

    <h2>Arbeitszeiten</h2>

    <WorktimeTable preselectedEmployeeId={employeeId} 
        preselectedEmployeeClosureId={employeeClosureId === 'new' ? null : employeeClosureIdInt} 
        begin={employeeClosureId === 'new' ? begin : undefined} 
        end={employeeClosureId === 'new' ? end : undefined}
        useEmployeeTimes={true} />

    <h2>Abwesenheit</h2>

    <AbsenceTable 
        preselectedEmployeeId={employeeId} 
        preselectedEmployeeClosureId={employeeClosureId === 'new' ? null : employeeClosureIdInt}
        begin={employeeClosureId === 'new' ? begin : undefined}
        end={employeeClosureId === 'new' ? end : undefined} />

    <h2>Nicht besuchte Kunden</h2>

    <NoVisitReasonTable preselectedEmployeeId={employeeId} preselectedEmployeeClosureId={employeeClosureIdInt} />

    <div style={{ marginBottom: "2em"}}>
      <Space size="small">
        <ConfirmButton type="default" danger onClick={onDelete} confirmTitle={`Abrechnung löschen?`} confirmContent={'Wollen Sie die Abrechnung wirklich löschen?'}>
          Abrechnung löschen
        </ConfirmButton>
      </Space>
    </div>

    <div ref={pdfReportContentRef} style={{ display: "none" }}>
      <h1>Stundenzettel</h1>
      <table>
        <tr>
          <td>Mitarbeiter:</td><td>{employee?.firstName} {employee?.lastName}</td>
        </tr>
        <tr>
          <td>Zeitraum:</td><td>{dayjs(closure?.begin).format('DD.MM.YYYY')} - {dayjs(closure?.end).subtract(1, 'day').format('DD.MM.YYYY')}</td>
        </tr>
      </table>

      <h2>Arbeitszeiten</h2>
      <table className="workTimes">
        <tr><th>Datum</th><th>Anfang</th><th>Ende</th><th>Kunde</th><th>Abw.</th><th>Stunden</th><th>KM hin</th><th>KM zurück</th><th>Einkauf</th></tr>
        { workTimes?.items?.map((wt, idx) => 
          <tr><td>{dayjs(wt.startTimeEmployee).format('DD.MM.YYYY')}</td><td>{dayjs(wt.startTimeEmployee).format('HH:mm')}</td><td>{dayjs(wt.endTimeEmployee).format('HH:mm')}</td><td><ReportCustomerName record={wt} /></td><td>{ dayjs(wt.startTimeEmployee).valueOf() !== dayjs(wt.startTime).valueOf() || dayjs(wt.endTimeEmployee).valueOf() !== dayjs(wt.endTime).valueOf() ? 'J' : 'N' }</td><td>{calcDuration(wt)}</td><td>{wt.distanceFromManual?.toFixed(1).replace('.', ',')}</td><td>{(workTimes?.items || [])[idx+ 1]?.arrivalFromPreviousCustomer ? '/' : wt.distanceToManual?.toFixed(1).replace('.', ',')}</td><td>{ wt.distanceShopping ? wt.distanceShopping.toFixed(2).replace('.', ',') : '' }</td></tr>
        ) }
        <tr><td colSpan={4} style={{ border: "none" }}></td><th style={{ border: "none" }}>Gesamt</th><th>{workTimes?.items ? formatTime(calcWorkTimesSum(workTimes.items)) : ''}</th><th>{workTimes?.items ? calcDistancesFromSum(workTimes.items).toFixed(1).replace('.', ',') : ''}</th><th>{workTimes?.items ? calcDistancesToSum(workTimes.items).toFixed(1).replace('.', ',') : ''}</th><th>{ workTimes?.items ? calcDistancesShoppingSum(workTimes.items).toFixed(1).replace('.', ',') : '' }</th></tr>
        <tr><td colSpan={5} style={{ border: "none" }}></td><th style={{ border: "none" }}>Gesamt KM</th><th colSpan={3}>{totalDistance}</th></tr>
      </table>

      <h2>Abwesenheiten</h2>
      <table className="absences">
        <tr><th>Beginn</th><th>Ende</th><th>Arbeitstage</th><th>Grund</th></tr>
        {absences?.items?.map((absence) =>
            <tr><td>{dayjs(absence.begin).format('DD.MM.YYYY')}</td><td>{dayjs(absence.end).format('DD.MM.YYYY')}</td><td>{absence.workingDays}</td><td>{absence.reason}</td></tr>
        )}
      </table>

      <h2>Nicht besuchte Kunden</h2>
      <table className="no-visits">
        <tr><th>Kunde</th><th>Grund</th></tr>
        {noVisitReasons?.items?.map((noVisitReason) =>
            <tr><td><ReportCustomerName record={noVisitReason} /></td><td>{noVisitReason.reason}</td></tr>
        )}
      </table>
    </div>
    </>)
}

export default EmployeeClosureDetails;